import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import Gnb from '../../components/Gnb';
import Post, { fillDetails } from '../../models/post';
import PostBox from '../../components/PostBox';

import PostActionBar from '../../components/PostBox/PostActionBar';
import ProfileBanner from '../../components/PostBox/ProfileBanner';
import CommentList from '../../components/CommentList';

import NotFoundPage from '../NotFoundPage';
import * as actions from '../../actions';

export class PostPage extends Component {
  static propTypes = {
    post: PropTypes.instanceOf(Post).isRequired,
    showModal: PropTypes.func,
    fetchComments: PropTypes.func,
    toggleDirectionAndEmptyItems: PropTypes.func
  };

  render() {
    const { post, showModal, wheel, device, fetchComments, toggleDirectionAndEmptyItems } = this.props;

    return (
      <div>
        <Gnb post={post} device={device} />

        { post ? (
          <div id="kakaoContent" className="cont_plus" role="main">
            <div id="mArticle">
              <h2 id="kakaoBody" className="screen_out">포스트 본문영역</h2>
              <div className="view_post">
                <PostActionBar post={post} 
                  showModal={showModal} 
                  wheel={wheel} 
                  device={device}
                />
                { post.isBlind() ? (
                  <div className="view_post">
                    <p className="desc_none">
                      <span className="ico_plus"></span>
                      운영정책에 의해 제재된 프로필로 모든 포스트가 블라인드되었습니다.
                    </p>
                  </div>
                  ) : (
                    <div>
                      <PostBox
                        post={post}
                        device={device}
                      />
                      <ProfileBanner
                        profile={post.author}
                        post={post}
                        showModal={showModal}
                        device={device}
                      />
                      <CommentList
                        post={post}
                        showModal={showModal}
                        fetchComments={fetchComments}
                        toggleDirectionAndEmptyItems={toggleDirectionAndEmptyItems}
                        device={device}
                      />
                    </div>
                  ) 
                }
              </div>
            </div>
          </div>
        ) : <NotFoundPage /> }
      </div>
    );
  }
}

const mapStateToProps = (state, { match: { params: { postId } } } ) => {
  const { entities, wheel, device } = state;
  const posts = entities.get('posts', Immutable.Map());
  const post = posts.map(post => fillDetails(post, entities))
    .get(`${postId}`);
  return { post, wheel, device };
};

export default connect(
  mapStateToProps, 
  (dispatch) => bindActionCreators({
    showModal: actions.showModal,
    fetchComments: actions.fetchComments,
    toggleDirectionAndEmptyItems: actions.toggleDirectionAndEmptyItems
  }, dispatch)
)(PostPage);



// WEBPACK FOOTER //
// ./src/containers/PostPage/index.js